import React from "react";
import { Lock, CheckCircle, Send, Eye, Archive, FileEdit } from "lucide-react";

const BADGE_CONFIG = {
  DRAFT:                { cls: "bg-slate-800/90 text-slate-300 border-slate-700",         icon: FileEdit },
  REVIEWED:             { cls: "bg-amber-950/80 text-amber-300 border-amber-700/60",      icon: Send },
  SUBMITTED_FOR_REVIEW: { cls: "bg-amber-950/80 text-amber-300 border-amber-700/60",      icon: Send },
  APPROVED:             { cls: "bg-emerald-950/80 text-emerald-300 border-emerald-700/60", icon: CheckCircle },
  PUBLISHED:            { cls: "bg-sky-950/80 text-sky-300 border-sky-700/60",             icon: Eye },
  LOCKED:               { cls: "bg-violet-950/80 text-violet-300 border-violet-700/60",    icon: Lock },
  RETIRED:              { cls: "bg-red-950/80 text-red-300 border-red-700/60",             icon: Archive },
};

export function LifecycleBadge({ status, className = "" }) {
  const cfg = BADGE_CONFIG[status] ?? { cls: "bg-slate-800/90 text-slate-400 border-slate-700", icon: null };
  const Icon = cfg.icon;
  return (
    <span
      data-testid={`lifecycle-badge-${(status || "unknown").toLowerCase()}`}
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${cfg.cls} ${className}`}
    >
      {Icon && <Icon className="w-3 h-3 flex-shrink-0" />}
      {status ?? "—"}
    </span>
  );
}
